let animalBreedFn = new function(){
    this.init=()=>{
        for(let link of document.querySelectorAll('.breed__alphabet-link a')){
            link.addEventListener('click', (e)=>{
                e.preventDefault();
                for(let allLink of document.querySelectorAll('.breed__alphabet-link a')){
                    allLink.classList.remove('actived');
                }
                e.target.classList.add('actived');

                var targetId = e.target.getAttribute('data-id');
                if(window.innerWidth < 768) {
                    for(let h1Mobole of document.querySelectorAll('.breed__capital.mobile')){
                        if(h1Mobole.classList.contains('actived') && h1Mobole.closest('.breed__container').getAttribute('id') != targetId){
                            h1Mobole.classList.remove('actived');
                        }else if(h1Mobole.closest('.breed__container').getAttribute('id') == targetId){
                            h1Mobole.classList.add('actived');
                        }
                    };
                }
                var des = document.getElementById(targetId);
                setTimeout(()=>{
                    window.scrollTo({top:des.offsetTop-55, behavior: 'smooth'});
                    setTimeout(()=>{
                        if(document.getElementById('shopify-section-header').classList.contains('shopify-section-header-sticky')){
                            document.getElementById('shopify-section-header').classList.add('shopify-section-header-hidden');
                        }
                    }, 1000);
                }, 350);
            });
        }

        for(var mobileHeader of document.querySelectorAll('.breed__capital.mobile')){
            mobileHeader.addEventListener('click', (e)=>{
                if(e.target.classList.contains('actived')){
                    e.target.classList.remove('actived');
                    let linksWrap = document.querySelector('.breed__alphabet-links');
                    if(linksWrap.querySelector('a.actived') != null){
                        linksWrap.querySelector('a.actived').classList.remove('actived');
                    }
                }else{
                    if(document.querySelector('.breed__capital.mobile.actived')!=null){
                        //document.querySelector('.breed__capital.mobile.actived').classList.remove('actived');
                    }
                    e.target.classList.add('actived');
                    let linksWrap = document.querySelector('.breed__alphabet-links');
                    if(linksWrap.querySelector('a.actived') != null){
                        linksWrap.querySelector('a.actived').classList.remove('actived');
                    }
                    var linkIdAttr = e.target.closest('.breed__container').getAttribute('id');
                    linksWrap.querySelector('[data-id="'+linkIdAttr+'"]').classList.add('actived');
                }
            });
        }

    }
    
}
animalBreedFn.init();

